"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseEventType = void 0;
var ResponseEventType;
(function (ResponseEventType) {
    ResponseEventType["USER_LOGGED_OUT"] = "userLoggedOut";
    ResponseEventType["PROFILE_CREATED"] = "profileCreated";
    ResponseEventType["PROFILE_UPDATED"] = "profileUpdated";
    ResponseEventType["PROFILE_DELETED"] = "profileDeleted";
})(ResponseEventType = exports.ResponseEventType || (exports.ResponseEventType = {}));
